import * as yup from "yup";
const numberOnlyRegex=/^[0-9]*$/
export const PaymentTermsValidation = yup.object({
  term_name: yup.string().required("Please enter term name"),
  term_days: yup.string().required("Please enter number of days").matches(numberOnlyRegex,"Please enter a valid number")
});
